import React from "react";
import { connect } from "react-redux";

import { getDinnerTopUpDefaultAmount, getStudentSchoolID, getExternalCashlessName, doesStudentUseExternalCashless } from "state/school_money/selectors";
import { addCreditTopUpToBasket } from "state/school_money/actions";

import CreditTopUp from "components/school_money/CreditTopUp";

class DinnerCreditTopUp extends React.Component {

  addToBasket = amount => {
    const { studentID, isExternal } = this.props;
    if(isExternal){
      this.props.addToBasket("external_top_up", studentID, amount);
    }else{
      this.props.addToBasket("dinner_money", studentID, amount);
    }
  }

  render() {
    const { defaultAmount, externalCashlessName, isExternal } = this.props;
    return (
      <CreditTopUp
        label={isExternal ? externalCashlessName + " Top Up" : "Dinner Top Up"}
        defaultAmount={defaultAmount}
        onAddToBasket={this.addToBasket}
      />
    )
  }

}

export default connect(
  (state, { studentID }) => {
    const schoolID = getStudentSchoolID(state, studentID);
    return {
      schoolID,
      defaultAmount: getDinnerTopUpDefaultAmount(state, schoolID),
      externalCashlessName: getExternalCashlessName(state, schoolID),
      isExternal: doesStudentUseExternalCashless(state, studentID)
    }
  },
  {
    addToBasket: addCreditTopUpToBasket
  }
)(DinnerCreditTopUp);



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/DinnerCreditTopUp.js